import React from "react";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";
import AIAnswerMetadataSources from "./AIAnswerMetadataSources";
import { AiAnswerSourceItem } from "./aiAnswerMetadata.types";

interface AIAnswerMetadataDetailsProps {
    localizer: IStringLocalizer;
    reasoning: string;
    confidenceReasoning: string;
    sources: AiAnswerSourceItem[];
}

const AIAnswerMetadataDetails: React.FC<AIAnswerMetadataDetailsProps> = ({
    localizer,
    reasoning,
    confidenceReasoning,
    sources
}) => (
    <div className="ai-answer-field__details">
        {reasoning.trim().length > 0 &&
            <div className="ai-answer-field__details-section">
                <p className="ai-answer-field__section-title">{localizer.localizeString("Reasoning:")}</p>
                <p className="ai-answer-field__reasoning">{reasoning}</p>
            </div>
        }

        {confidenceReasoning.trim().length > 0 &&
            <div className="ai-answer-field__details-section">
                <p className="ai-answer-field__section-title">{localizer.localizeString("Confidence Score Explanation:")}</p>
                <p className="ai-answer-field__confidence-reasoning">{confidenceReasoning}</p>
            </div>
        }

        <AIAnswerMetadataSources localizer={localizer} sources={sources} />
    </div>
);

export default AIAnswerMetadataDetails;
